import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { atcb_init as atcbInit } from 'add-to-calendar-button';
import 'add-to-calendar-button/assets/css/atcb.css';

const AddToCalendarButton = ({ eventCalendar, className }) => {
     const currentUser = useSelector((state) => state.subscriber.user);

     const atcbConfiguration = `
          "name": "${eventCalendar.name}",
          "description": "${eventCalendar.description}",
          "startDate": "${eventCalendar.startDate}",
          "endDate": "${eventCalendar.endDate}",
          "startTime": "${eventCalendar.startTime}",
          "endTime": "${eventCalendar.endTime}",
          "timeZone": "${currentUser?.timezone ?? eventCalendar.timeZone}",
          "location": "${eventCalendar.locationDescription}",
          "label": "${eventCalendar.label}",
          "options": ${JSON.stringify(eventCalendar.calendarOptions)},
          "trigger": "${eventCalendar.trigger}",
          "inline": "true",
          "iCalFileName": "${eventCalendar.iCalFileName}"
     `;

     useEffect(atcbInit, []);

     return (
          <div
               className={classNames('atcb btn-calendar-wrap', {
                    [className]: className,
               })}
               style={{ display: 'none' }}
          >
               {'{'} {atcbConfiguration} {'}'}
          </div>
     );
};

AddToCalendarButton.propTypes = {
     eventCalendar: PropTypes.shape({
          name: PropTypes.string,
          calendarOptions: PropTypes.array,
          description: PropTypes.string,
          iCalFileName: PropTypes.string,
          label: PropTypes.string,
          locationDescription: PropTypes.string,
          startDate: PropTypes.string,
          endDate: PropTypes.string,
          startTime: PropTypes.string,
          endTime: PropTypes.string,
          timeZone: PropTypes.string,
          trigger: PropTypes.string,
     }),
     className: PropTypes.string,
};

AddToCalendarButton.defaultProps = {
     trigger: 'hover',
};

export default AddToCalendarButton;
